import _ from "underscore";
import m, {VnodeDOM} from "mithril";
import prop from "mithril/stream";
import {Point} from "../../../model/utils";
import {DragItem, DragValue} from "../../../model/items/dragdrop/dragItem";

export class DragItemView {
    public hover = false;
    public canAccept = false;

    public cellItem: DragItem;
    public element?: HTMLElement;
    private lastValue?: DragValue;
    private that: DragItemView; // smells like dirty way ... anyway, this is capable to keep real this

    constructor(attr: any) {
        this.cellItem = <DragItem> attr.cellItem;
        this.element = undefined;
        this.that = this;
    }

    public hit(p: Point): boolean {
        if (this.element === undefined) {
            return false;
        }
        const rect = this.element.getBoundingClientRect();
        return rect.left < p.x && p.x < rect.right && rect.top < p.y && p.y < rect.bottom;
    }

    protected getContent() {
        const droppedValue = this.cellItem.droppedValue;
        let content = droppedValue ? droppedValue.getView() : "---";
        // HACK to make mithril redraw droppable
        /* tslint:disable */
        if( !this.lastValue || this.lastValue != droppedValue ) {
            /* tslint:enable */
            this.lastValue = droppedValue;
            content = "---";
            setTimeout(() => m.redraw(), 1);
        }
        return content;
    }

    protected getClass() {
        return [
            this.hover ? "hover" : null,
            this.canAccept ? "accept" : null,
        ].filter(_.isString).join(" ");
    }

    /**
     * Set Element into this. real this with all that OOP inheritance stuff ;-)
     * @param vnode
     */
    setElement(vnode: VnodeDOM) {
        this.that.element = <HTMLElement>vnode.dom;
    }
}